export const iconFontAwesomeConnectivitySignal = (
	<i className="fa-solid fa-signal"></i>
);
